module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /home/g0/live-stream/web-client/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = ZWLL
// module chunks = 5 6 7 8